var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 38,
    viewBox: "0 0 130 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.768 20.7678C129.744 19.7915 129.744 18.2085 128.768 17.2322L112.858 1.32233C111.882 0.34602 110.299 0.34602 109.322 1.32233C108.346 2.29864 108.346 3.88155 109.322 4.85786L123.464 19L109.322 33.1421C108.346 34.1184 108.346 35.7014 109.322 36.6777C110.299 37.654 111.882 37.654 112.858 36.6777L128.768 20.7678ZM0 21.5L127 21.5V16.5L0 16.5L0 21.5Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.09c277d2a90fa6e8688be1f0b4692f91.svg";
export { ForwardRef as ReactComponent };